/*
 Dashboard component
 url match: /dashboard
 Base component for the home page, redirects to appropriate 
 components depending on the URL/Route
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import Sidebar from './Sidebar';
import { Switch, Route } from 'react-router-dom';
import DocumentList from './DocumentList';
import Loader from 'react-loader-spinner'
import TemplateList from '../Templates/TemplateList';

/*const StyledDrawer = styled(Drawer)`
  & > div {
    width: 16%;
  }
`; */

@inject('userStore')
@observer
class Dashboard extends React.Component {
  
  state = {
    active: 'drafts'
  }

  render() {
    const { classes } = this.props;
    if (this.props.userStore.logoutProgress) {
      return (
        <div className={classes.loaderDiv}>
          <Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} />
        </div>
      )
    }
    return (
      <div className={classes.dashboardContainer}>
        <Sidebar activeTab={this.state.active} ></Sidebar>
        <main className={classes.content} >
          {/*Match routes to components */}
          <Switch>
            <Route path={this.props.match.url + '/templates'} exact={true} component={() => <TemplateList active="templates" />} />
            <Route path={this.props.match.url + '/aiPending'} exact={true} component={() => <DocumentList filter="AI_PENDING" heading="AI Pending" active="ai pending" />} />
            <Route path={this.props.match.url + '/drafts'} exact={true} component={() => <DocumentList filter="REVIEW_PENDING" heading="Drafts" active="drafts" />} />
            <Route path={this.props.match.url + '/reviewed'} exact={true} component={() => <DocumentList filter="REVIEW_COMPLETE" heading="Reviewed Documents" active="reviewed" />} />
            <Route path={this.props.match.url + '/exported'} exact={true} component={() => <DocumentList filter="EXPORTED" heading="Exported Documents" active="exported" />} />
          </Switch>
        </main>
      </div>
    );
  }
}
export default withStyles(dashboardStyles, { withTheme: true })(withRouter(Dashboard));
